import packageDataMapper from './nordic-mapper'

const fontMapper = {
  8: {
    fontSize: 68,
    margin: [0, 20, 0, 20],
  },
  9: {
    fontSize: 64,
    margin: [0, 23, 0, 23],
  },
  10: {
    fontSize: 60,
    margin: [0, 27, 0, 27],
  },
  11: {
    fontSize: 54,
    margin: [0, 35, 0, 35],
  },
  12: {
    fontSize: 44,
    margin: [0, 35, 0, 35],
  },
  default: {
    max: 13,
    fontSize: 36,
    margin: [0, 35, 0, 35],
  }
}
function findTheFontSize (docDefinition, mapper) {
  if (docDefinition) {
    for (let i = 0; i < docDefinition.content.length; i++) {
      const text = docDefinition.content[i]?.text
      if (text) {
        const attitude = Object.keys(mapper).find(el => {
          return Number(el) === text.length
        })
        if (attitude) {
          const { fontSize, margin } = mapper[attitude]
          docDefinition.content[i] = { ...docDefinition.content[i], fontSize, margin }
        } else if (text.length > mapper.default.max) {
          const { fontSize, margin } = mapper.default
          docDefinition.content[i] = { ...docDefinition.content[i], fontSize, margin }
        }
      }
    }
  }
}

const mapPackageData = (packageData) => {
  const data = { ...packageData }
  for (const key of Object.keys(packageDataMapper)) {
    const items = Object.entries(packageDataMapper[key])
    const attitude = items.find(([innerKey, _]) => Number(innerKey) === data[key] || innerKey === data[key])
    if (attitude) {
      data[key] = attitude[1]
    } else {
      data[key] = '-'
    }
  }
  return data
}

export const generateLabelsNordic = (packages_data) => {
  const docDefinition = {
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [0, 15, 0, 0],
    content: [],
    defaultStyle: {},
    styles: {
      header: {
        fontSize: 48,
        lineHeight: 0.8,
        bold: true,
        alignment: 'center',
      },
      subheader: {
        fontSize: 36,
        bold: true,
        alignment: 'center'
      },
      subsubheader: {
        fontSize: 28,
        alignment: 'center'
      }
    }
  }
  const noBorders = [false, false, false, false]

  for (let i = 0; i < packages_data.length; i++) {
    const {
      package_nr,
      barcode_img,
      children,
    } = packages_data[i]
    const dataForPdf = mapPackageData(packages_data[i])
    const attitudeSizes = `${dataForPdf.thickness}x${dataForPdf.width}`.toUpperCase()
    docDefinition.content.push(
      { alignment: 'center', image: barcode_img, width: 505, height: 52, margin: 5, pageBreak: i !== 0 ? 'before' : null },
      {
        text: package_nr ? package_nr.toUpperCase() : '-',
        style: 'header',
        margin: [0, 0, 0, 5]
      },
      // special table to have just have a border before
      {
        margin: [0, 0, 0, 0],
        width: '100%',
        table: {
          widths: ['100%'],
          body: [
            [{ border: [false, true, false, false], text: '' }]
          ]
        }
      },
      {
        columns: [
          {
            width: '100%',
            margin: [0, 0, 0, 0],
            layout: 'noBorders',
            table: {
              widths: ['50%', '50%'],
              body: [
                [
                  [
                    {
                      columns: [
                        [
                          {
                            width: '50%', text: 'Nordic', border: noBorders, style: 'header',
                            fontSize: 32
                          },
                          {
                            width: '50%', text: dataForPdf.wood, border: noBorders, style: 'header',
                            fontSize: dataForPdf.wood.length > 6 ? 24 : 48
                          }
                        ],
                        [
                          { text: dataForPdf.humidity, style: 'subheader' },
                          {
                            text: dataForPdf.profile,
                            style: 'subheader',
                            fontSize: dataForPdf.profile.length > 5 ? 24 : 36
                          }
                        ]
                      ]
                    },
                    {
                      columns: [
                        {
                          width: '50%', text: attitudeSizes, border: noBorders,
                          style: 'header', fontSize: attitudeSizes.length > 5 ? 40 : 52, margin: [5, 8, 0, 0]
                        },
                        {
                          text: dataForPdf.length === '-' ? dataForPdf.length : `${dataForPdf.length}'`,
                          style: 'header', fontSize: dataForPdf.length.includes('PET') ? 28 : 56
                        }
                      ]
                    },
                    {
                      text: dataForPdf.sizes.toUpperCase() + ' (mm)', border: noBorders, style: 'subsubheader', bold: true,
                      margin: [0, 10, 0, 0]
                    },
                  ],
                  [
                    {
                      text: dataForPdf.quality, border: noBorders, style: 'header',
                      margin: [0, 0, 0, dataForPdf.quality.includes('NORDIC') ? 0 : 10], lineHeight: 1.0
                    },
                    {
                      text: dataForPdf.amount, border: noBorders, style: 'header'
                    },
                  ]
                ],
                [
                  [
                    {
                      text: 'Distributed by:', border: noBorders, fontSize: 20, alignment: 'center',
                      margin: [0, 22, 0, 0]
                    },
                    {
                      text: 'Olympic industries', border: noBorders, style: 'subsubheader', bold: true,
                      margin: [0, 10, 0, 0]
                    }
                  ],
                  [
                    {
                      text: 'Mill 710', border: noBorders, style: 'subsubheader', bold: true,
                      margin: [0, 20, 0, 0]
                    },
                    {
                      text: 'Product of Lithuania', border: noBorders, style: 'subsubheader',
                    }
                  ]
                ]
              ]
            }
          }
        ]
      }
    )
    if (children && children.length > 0) {
      const table = {
        pageBreak: 'before',
        margin: [5, 15, 5, 5],
        table: {
          widths: [570],
          body: [
            [{
              text: package_nr,
              style: 'subheader',
              margin: [5, 15, 5, 15],
              border: [false, false, false, false]
            }]
          ]
        }
      }
      for (let j = 0; j < children.length; j++) {
        table.table.body.push([{
          text: children[j],
          style: 'subsubheader',
          border: [true, true, true, true]
        }])
      }
      docDefinition.content.push(table)
    }
  }
  // findTheFontSize(docDefinition, fontMapper)
  return docDefinition
}



// WEBPACK FOOTER //
// ./src/helpers/pdf-labels/labels-nordic.js